import trackingService from "app/pages/sales-intelligence/services/tracking/createMultiSelectorPanelService";
import type { ComponentType } from "react";
import type { SelectionDropdownItem } from "../../../table-actions-panel/models/selection-dropdown-item/types";

type ExpectedProps = {
    numberOfResults: number;
    onSubmit(item: Readonly<SelectionDropdownItem>): void;
};

export default function withActivatedRemoveFromListPanelTracking<P extends ExpectedProps>(PanelCmp: ComponentType<P>) {
    return function WrappedWithActivatedRemoveFromListPanelTracking(props: P) {
        function handleSubmit(item: Readonly<SelectionDropdownItem>) {
            trackingService.trackMultiSelectorRemoveClick(props.numberOfResults, item.value);
            props.onSubmit(item);
        }

        return (
            <PanelCmp
                {...props}
                onSubmit={handleSubmit}
            />
        );
    };
}
